const getInitials = ({ name, givenName, lastName }: { name?: string; givenName?: string; lastName?: string }) => {
    let names;

    if (name) {
        names = name.trim().split(' ');
    } else if (givenName && lastName) {
        names = [givenName, lastName];
    } else {
        return 'AB';
    }

    if (names.length > 1) {
        const firstInit = names[0].charAt(0).toUpperCase();
        const lastInit = names[1].charAt(0).toUpperCase();

        return `${firstInit}${lastInit}`;
    }

    return names[0].charAt(0).toUpperCase();
};

const getEmailInitials = (email: string): string => {
    const localPart = email.split('@')[0];
    const segments = localPart.split('.');
    if (segments.length === 1) {
        return segments[0].charAt(0).toUpperCase();
    }
    const firstInit = segments[0].charAt(0).toUpperCase();
    const lastInit = segments[segments.length - 1].charAt(0).toUpperCase();
    return `${firstInit}${lastInit}`;
};

const getFullNameFromEmail = (email: string): string => {
    const localPart = email.split('@')[0];
    const segments = localPart.split('.');
    return segments.map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1)).join(' ');
};

/**
 * Check if user is admin based on backend roles.
 * Backend uses dual verification (IAM group + database role).
 * Both must be true for user to have ADMIN role.
 *
 * @param user - User object from UserContext (should include roles array from backend)
 * @returns true if user has ADMIN role, false otherwise
 */
const isUserAdmin = (user: any): boolean => {
    return user?.roles?.includes('ADMIN') || false;
};

export { getInitials, isUserAdmin, getEmailInitials, getFullNameFromEmail };
